// Module
var code = "<div class=\"flex layout-column\">\r\n    <mn-system-parameter class=\"flex\" key=\"oximetry_config\" attr=\"chart_colors\">\r\n        <mn-oximetry-config-table mn-model=\"vm.model\" mn-auto-save=\"vm.handleAutoSave\" attr=\"chart_colors\">\r\n        </mn-oximetry-config-table>\r\n    </mn-system-parameter>\r\n</div>";
// Exports
module.exports = code;